const bootstrap = require('bootstrap');
require('bootstrap-icons/font/bootstrap-icons.css');
import '../src/common';

import '../stylesheets/application';

import '../src/console/link_field';
import '../src/console/json_pre';
import '../src/file_upload_preview';

window.ChatBuilder = require('../src/console/chat').default;
